
import isValidUkPostcode from "../helpers/isValidUkPostcode"
import AppButton from "./AppButton"
import FeedbackDialog from "./FeedbackDialog"

export default {
  components: {
    AppButton,
    FeedbackDialog
  },
  props: {
    variant: {
      type: String,
      default: null
    },
    buttonLabel: {
      type: String,
      default: "Get Quote"
    },
    hasBorder: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    postcode: {
      type: String,
      default: ""
    },
    errorMessage: {
      type: String,
      default: ""
    },
    backgroundColor: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      quotePostcode: "",
      showInputMessage: false,
      showInvalidMessage: false,
      postcodeTopPosition: false
    }
  },
  watch: {
    postcode(value) {
      if (value) this.quotePostcode = value
    }
  },
  mounted() {
    this.quotePostcode = this.postcode
  },
  methods: {
    validatePostcode() {
      let data = {
        customerPostcode: this.quotePostcode
      }
      if (!this.quotePostcode) {
        this.showInputMessage = true
      } else {
        if (isValidUkPostcode(this.quotePostcode)) {
          this.$emit("postcode-is-valid", data)
          this.showInvalidMessage = false
        } else {
          this.showInvalidMessage = true
        }
      }
    }
  }
}
